export function deduplicateById<T extends { id: string }>(data: T[]) {
    return data.filter(
        (element, index, array) => array.findIndex(innerElement => innerElement.id === element.id) === index
    );
}
